import React, { useState } from "react"
import styles from "./Collapsible.module.scss"

interface CollapsibleProps {
  title: string
  children: React.ReactNode
}

const Collapsible: React.FC<CollapsibleProps> = ({ title, children }) => {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <button className={styles.collapsible} onClick={() => setIsOpen(!isOpen)}>
      <h3 className={styles.title}>{title}</h3>
      {isOpen && <p className={styles.p}>{children}</p>}
    </button>
  )
}

export default Collapsible
